import React, { useEffect, useState } from 'react';
import { message, Divider } from 'antd';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AutoSelectClient from './auto_select_client';
import AutoSelectProduct from './auto_select_products';
import AutoSelectColors from './auto_select_colors';
import AutoSelectTypeQuantity from './auto_select_type_quantity';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DateDeliveryPicker from './date_delivery_picker';
import InfoClientModal from './info_client_modal';
import ExtraInfoOrders from './extra_info_orders';
import { 
  getQType
} from '../../../_events/orders/generate_order.inputs';
import { 
  addItemOrderEvent,
  selectClientForOrderEvent,
  generateOrderEvent
} from '../../../_events/orders/generate_order.event';
import {  
  findClientsBySellerCompanyEvent
} from '../../../_events/clients/find_clients.event';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';

const CreateOrder = () => {

  const [loadingClients, setLoadingClients] = useState(false);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [loadingSelectClient, setLoadingSelectClient] = useState(false);
  const [client, setClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [items, setItems] = useState([]);
  const [price, setPrice] = useState(0);
  const [renderInfo, setRenderInfo] = useState(false);

  useEffect(() => {
    loadClients();
  }, []);

  const createUUID = () => {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c==='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
  }

  const gotToSelectClient = () => {
    setClient(null);
    setItems([]);
    setProducts([]);
    setPrice(0);
    setRenderInfo(false);
  }

  const loadClients = () => {
    setLoadingClients(true);
    findClientsBySellerCompanyEvent()
    .then(data => {
      setClients(data.list);
      setLoadingClients(false);
    })
    .catch(err => {
      setLoadingClients(false);
      message.error(err.message);
    });
  }

  const selectClient = () => {
    setItems([]);
    setLoadingSelectClient(true);
    selectClientForOrderEvent(clients)
    .then(data => {
      setProducts(data.products);
      setClient(data.client);
      setRenderInfo(true);
      setLoadingSelectClient(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoadingSelectClient(false);
    });
  }

  const selectProduct = (productP) => {
    setProduct(productP);
    if(!productP){
      setPrice(0);
    } else {
      let type = getQType();
      if(type === 'MTS') setPrice(productP.price_mt ? productP.price_mt : 0);
      else if(type === 'KG') setPrice(productP.price_kg ? productP.price_kg : 0);
      
    }
  }

  const selectType = (type) => {
    if(!product){
      setPrice(0);
    } else {
      if(type.cod === 'MTS') setPrice(product.price_mt ? product.price_mt : 0);
      else if(type.cod === 'KG') setPrice(product.price_kg ? product.price_kg : 0);
      
    }
  }

  const addItem = () => {
    addItemOrderEvent(price)
    .then(data => {
      let items_c = [...items];
      data.id = createUUID();
      items_c.push(data);
      setItems(items_c);
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const removeItem = (item) => {
    let items_c = [...items];
    let index = items_c.findIndex(i => i.id === item.id);
    if(index === -1){
      message.error('No se logró eliminar');
    } else {
      items_c.splice(index, 1);
      setItems(items_c);
    }    
  }

  const generateOrder = () => {
    setLoadingOrder(true);
    generateOrderEvent(items)
    .then(data => {
      setLoadingOrder(false);
      message.success(`Pedido generado: # ${data.data.id}`);
      setRenderInfo(false);
      setPrice(0);
    })
    .catch(err => {
      message.error(err.message);
      setLoadingOrder(false);
    });
  }

  return (
    <Grid container spacing={1} >
        {
          renderInfo ? 
          <ProductsInfo
            client={client}
            onChangeProduct={(product) => selectProduct(product)}
            onChangeType={(p) => selectType(p)}
            addItem={() => addItem()}
            removeItem={(p) => removeItem(p)}
            items={items}
            products={products}
            sendOrder={() => generateOrder()}
            price={price}
            gotToSelectClient={gotToSelectClient}
            loadingOrder={loadingOrder}
          />
          :
          <>
            <Grid item xs={12} md={12}>
              <Typography variant="h6" component="h6">
                Generar nuevo pedido
              </Typography>
              <hr />
            </Grid>
            <SelectClient
              render={!loadingClients}
              clients={clients}
              onClick = {() => selectClient()}
              loadingSelectClient = {loadingSelectClient}
            />
          </>
        }
    </Grid>
  );
}

const SelectClient = (props) => {
  if(!props.render || props.loadingSelectClient){
    return(
     <PrimaryProgress />
    );
  } else {
    return(
      <Grid style={{marginTop: '10px'}} container spacing={1} >
          <Grid item xs={12} md={8}>
            <AutoSelectClient
              clients={props.clients}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Button 
              style={{width: '100%'}}
              variant="contained"
              onClick={props.onClick}
            >
              Seleccionar
            </Button>
          </Grid>
      </Grid>
    );    
  }
  
}

const ProductsInfo = (props) => {
  const renderCreateOrder = () => {
    if(props.loadingOrder) return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Cargando...</div>
    return(
      <BasicPopconfirm
        width={'100%'}
        label='Enviar'
        title='¿Seguro/a que deseas enviar la orden?'
        onConfirm={ () => props.sendOrder()}
      />
    );
  }

  return(
    <Grid item xs={12} md={12} >
      <Grid item xs={12} md={12}>
        <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
            <div style={{display: 'flex', flexDirection: 'row', width:'60%'}}>
            <Typography variant="h6" component="h6">
                Información de pedido
            </Typography>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'40%'}}>                
              <Button size='small' onClick={() => props.gotToSelectClient()} variant="contained">Cambiar cliente</Button>
            </div>
        </div>
        <hr />
      </Grid>
      <Grid item xs={12} md={12}>
        <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
          <div style={{display: 'flex', flexDirection: 'row', width:'60%'}}>
            <strong style={{fontSize: '16px'}}>{props.client ? props.client.name : ''}</strong>
            <InfoClientModal client={props.client} />
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'40%'}}>                
            <ExtraInfoOrders client={props.client} />
          </div>
        </div>
      </Grid>
      <AddProduct
        items={props.items}
        onChangeProduct={(products) => props.onChangeProduct(products)}
        onChangeType={(p) => props.onChangeType(p)}
        addItem={() => props.addItem()}
        removeItem= {(p) => props.removeItem(p)}
        products={props.products}
        price={props.price}
      />
      <Grid item xs={12} md={12}>
        <TextField
          style={{width: '100%', marginTop: '10px', marginBottom: '20px'}}
          id="order_purchase_order"
          label="Orden de compra"
          size='small'
          type="text"
        />
      </Grid>
      <DateDeliveryPicker />
      <Grid item xs={12} md={12}>
        <TextField
          style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}
          id="order_address_delivery"
          label="Dirección de envío"
          size='small'
          defaultValue={props.client ? props.client.address : null}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}
          id="order_notes"
          label="Notas"
          multiline
          rows={4}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        {renderCreateOrder()}
      </Grid>
    </Grid>
  );
}

const AddProduct = (props) => {

  const [total, setTotal] = useState(0);

  useEffect(() => {
    let add = 0;
    props.items.map((p) => {add+= (p.price * p.quantity)});
    setTotal(add);
  },[props.items]);

  return(
    <>
    <Grid style={{marginTop: '10px'}} container spacing={1} >
        <Grid item xs={1.8} md={2}>
          <strong style={{fontSize: '10px'}}>Producto</strong>
        </Grid>
        <Grid item xs={1.5} md={2}>
          <strong style={{fontSize: '10px'}}>Color</strong>
        </Grid>
        <Grid item xs={1.8} md={1}>
          <strong style={{fontSize: '10px'}}>Cantidad</strong>
        </Grid>
        <Grid item xs={1.5} md={1}>
          <strong style={{fontSize: '10px'}}>Medida</strong>
        </Grid>
        <Grid item xs={2} md={2.5}>
          <strong style={{fontSize: '10px'}}>(COP) Und.</strong>
        </Grid>
        <Grid item xs={2} md={2.5}>
          <strong style={{fontSize: '10px'}}>(COP) Total</strong>
        </Grid>
    </Grid>
    {
      props.items.map((p, key) => {
        return(
          <>
            <Grid key={key} style={{marginTop: '10px'}} container spacing={1} >
              <Grid item xs={1.8} md={2}>
                <span style={{fontSize: '9px', fontFamily: 'monospace'}}>{p.product_ref}</span>
              </Grid>
              <Grid item xs={1.5} md={2}>
                <span style={{fontSize: '9px', fontFamily: 'monospace'}}>{p.color_ref}</span>
              </Grid>
              <Grid item xs={1.8} md={1}>
                <span style={{fontSize: '9px', fontFamily: 'monospace'}}>{p.quantity}</span>
              </Grid>
              <Grid item xs={1.5} md={1}>
                <span style={{fontSize: '9px'}}>{p.type_quantity}</span>
              </Grid>
              <Grid item xs={2} md={2.5}>
                <span style={{fontSize: '9px', fontFamily: 'monospace'}}>(COP) {p.price}</span>
              </Grid>
              <Grid item xs={2} md={2.5}>
                <span style={{fontSize: '9px', fontFamily: 'monospace'}}>(COP) {p.price * p.quantity}</span>
              </Grid>
              <Grid item xs={1} md={1}>
              <IconButton onClick={() => props.removeItem(p)} style={{marginTop: '-10px'}} aria-label="cart">
                  <DeleteOutlineIcon style={{color:'red'}} />
              </IconButton>
              </Grid>              
          </Grid>
          <Divider style={{marginTop: '-1px', marginBottom: '-10px'}} />
        </>
        );
      })
    }
    <hr />
    <Grid style={{marginTop: '10px'}} container spacing={1} >
        <Grid item xs={2} md={2}>
        </Grid>
        <Grid item xs={2} md={2}>
        </Grid>
        <Grid item xs={1} md={1}>
        </Grid>
        <Grid item xs={1} md={1}>
        </Grid>
        <Grid item xs={2.5} md={2.5}>
        </Grid>
        <Grid item xs={2.5} md={2.5}>
          <strong style={{fontSize: '10px', fontFamily: 'monospace'}}>(COP) {total}</strong>
        </Grid>
    </Grid>
    <hr />
    <Grid style={{marginTop: '10px'}} container spacing={1} >
        <Grid item xs={12} md={3}>
          <AutoSelectProduct
            products={props.products}
            onChange={(p) => props.onChangeProduct(p)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <AutoSelectColors
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <TextField
            style={{width: '100%'}}
            id="order_quantity"
            label="Cantidad"
            size={'small'}
            type="number"
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <AutoSelectTypeQuantity
            width={'100%'}
            onChange={(p) => props.onChangeType(p)}
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <div style={{display : 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width:'100%'}}>
            <span style={{fontWeight: 'bold'}}>(COP) Unid. {props.price}</span>
          </div>
        </Grid>
        <Grid item xs={12} md={12}>
          <Button 
            style={{width: '100%'}}
            variant="contained"
            onClick={() => props.addItem()}
          >
            Agregar
          </Button>
        </Grid>
    </Grid>
    <hr />
    </>
  );
}

export default CreateOrder;
